import { render, staticRenderFns } from "./DoctorAppointmentRestrictionsModal.vue?vue&type=template&id=3dbcf41b&scoped=true&"
import script from "./DoctorAppointmentRestrictionsModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorAppointmentRestrictionsModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorAppointmentRestrictionsModal.vue?vue&type=style&index=0&id=3dbcf41b&lang=scss&"
import style1 from "./DoctorAppointmentRestrictionsModal.vue?vue&type=style&index=1&id=3dbcf41b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbcf41b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbcf41b')) {
      api.createRecord('3dbcf41b', component.options)
    } else {
      api.reload('3dbcf41b', component.options)
    }
    module.hot.accept("./DoctorAppointmentRestrictionsModal.vue?vue&type=template&id=3dbcf41b&scoped=true&", function () {
      api.rerender('3dbcf41b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DoctorAppointmentRestrictionsModal/DoctorAppointmentRestrictionsModal.vue"
export default component.exports